export default "__VITE_ASSET__1a123290__"